var availableFonts = {
    'Style 1':
    {
        displayName: "Style 1",
        overlapThreshold: 40,
        fontSize: 72
    },
    'Style 2':
    {
        displayName: "Style 2",
        overlapThreshold: 40,
        fontSize: 52
    },
    'Style 3':
    {
        displayName: "Style 3",
        overlapThreshold: 40,
        fontSize: 70
    },
    'Style 4':
    {
        displayName: "Style 4",
        overlapThreshold: 40,
        fontSize: 70
    },
    'Style 5':
    {
        displayName: "Style 5",
        overlapThreshold: 40,
        fontSize: 80
    },
    'Style 6':
    {
        displayName: "Style 6",
        overlapThreshold: 40,
        fontSize: 72
    },
    'Style 7':
    {
        displayName: "Style 7",
        overlapThreshold: 40,
        fontSize: 72
    },
    'Style 8':
    {
        displayName: "Style 8",
        overlapThreshold: 21,
        fontSize: 72
    },
  	'Style 9':
    {
        displayName: "Style 9",
        overlapThreshold: 21,
        fontSize: 72
    }
};